import {
  useCompanyReadDataContext,
  usePersonReadDataContext,
} from '@aibees/elephant/context';
import {
  useReadCompany,
  useReadPerson,
  useSearchTypeFromRoute,
} from '@aibees/elephant/hooks';
import { useBootstrapApi } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-api';
import { usePageType } from '@aibees/elephant/hooks/use-page-type';
import { SearchType } from '@aibees/elephant/types';
import { LabelType } from '@aibees/elephant/types/label';
import { IconName } from '@aibees/shared/components';

export function useRecordManagementLabels(
  labelType?: LabelType,
  itemId?: string
) {
  const type = useSearchTypeFromRoute();
  const { isPeoplePage, isCompanyPage } = usePageType();
  const { data: companyItem } = useReadCompany(
    isCompanyPage ? itemId : undefined
  );
  const { data: peopleItem } = useReadPerson(isPeoplePage ? itemId : undefined);
  const { api: companyData } = useCompanyReadDataContext();
  const { api: personData } = usePersonReadDataContext();
  const isPeople = type === SearchType.People || isPeoplePage;
  const isLabel = labelType === LabelType.LABEL;
  const emptyTitle = isLabel ? 'No Labels' : 'No Lists';
  const title = isLabel ? 'Create/Add Label' : 'Create/Add List';
  const recordLabel = isLabel ? 'Add Label' : 'Add List';
  const icon: IconName = isLabel ? 'tags' : 'list';

  const company = itemId ? companyItem : companyData?.data;
  const people = itemId ? peopleItem : personData?.data;

  const data = isPeople ? people : company;
  const id = data?.id;
  const { data: allLabels } = useBootstrapApi();
  const labels =
    (data?.labels &&
      allLabels?.labels.filter((x) => data.labels?.includes(x.id))) ||
    [];

  const filteredLabels = labels.filter((x) => x.type === labelType);
  const lastItem = filteredLabels.at(0);
  const labelsCount = labels.length;

  return {
    id,
    filteredLabels,
    emptyTitle,
    title,
    recordLabel,
    icon,
    lastItem,
    labelsCount,
  };
}
